<template>
    <ImagesGestionPage />
</template>

<script>
import ImagesGestionPage from '@/components/ImagesGestionComponent.vue';

export default {
  components: {
    ImagesGestionPage
  }
}
</script>
